import React, { useEffect, useState } from "react";
import { MainLayout } from "../Components/MainLayout";
import { DiscountBox } from "../Components/DiscountBox";
import SimplePlan from "../Components/Plans/SimplePlan";
import { GoldPlan } from "../Components/Plans/GoldPlan";
import Cookies from "js-cookie";
import { fetchData } from "../../Cpanel/Components/Utilities";
import { InsuranceState } from "../Components/Plans/InsuranceState";

const InsurancePayment = () => {
  const [userStatus, setUserStatus] = useState("");
  const [isOrganizationUser, setIsOrganizationUser] = useState(true);
  // api to check is org and status 0 or 1 (plan) ==> setIsOrganizationUser(true)
  useEffect(() => {
    const bodyFormData = new FormData();
    bodyFormData.append("guid", Cookies.get("guid"));
    fetchData("guid", bodyFormData, handleApiResponse);
  }, []);
  const handleApiResponse = (data) => {
    setUserStatus(data?.userinfo?.grade);
    if (data?.userinfo?.org === 0) {
      setIsOrganizationUser(true);
    }
  };
  return (
    <>
      <DiscountBox />
      {isOrganizationUser ? (
        <>
          <div>وضعیت کاربر: سازمانی یا غیر سازمانی{userStatus}</div>

          <div className="overflow-x-auto ">
            {userStatus === 1 && <GoldPlan />}
            {userStatus === 2 && <InsuranceState />}
          </div>
        </>
      ) : (
        <div>
          <div>غیر سازمانی</div>

          <p>پرداخت حق عضویت به صورت</p>
          <p> نقدی</p>
        </div>
      )}
    </>
  );
};
export default () => <MainLayout children={<InsurancePayment />} />;
